// extracted by mini-css-extract-plugin
export default {"searchField":"TeamList_searchField__rFeR2","actions":"TeamList_actions__CqL1O","teamList":"TeamList_teamList__0YqLw","paper":"TeamList_paper__9JwTe"};